import React from "react";
import { Helmet } from "@/components/Helmet";
import { getSubjectListUrl, getHost } from "@/utils/URL";

const SubjectHelmet = (props: {
  tabName?: string;
  pageIndex: number;
  list?: (string | undefined)[];
}) => {
  const { tabName = "", pageIndex = 1, list = [] } = props;

  const handleTitle = () => {
    let dynamic = "";

    if (!tabName) {
      // 首页
      dynamic = "";
    } else {
      // 非首页
      dynamic = tabName.toUpperCase() + (pageIndex > 1 ? `_${pageIndex}` : "");
    }

    return [`All Story Types Read Online`, dynamic, "WebNovel"]
      .filter((v) => v)
      .join(" - ");
  };

  const handleDesc = () => {
    const keywordsList = list.slice(0, 3).join(", ");
    return `The data of story types are derived from search keywords and tags describing novels or stories. We offers a vast collection of popular web novels in every genre, like Romance, Fantasy, Sci-fi, ${keywordsList} etc.`;
  };

  const title = handleTitle();
  const description = handleDesc();
  const keywords =
    "story types, novel keywords, novel tags, light fiction, web novel, good reads";

  const canonical = `${getHost()}${getSubjectListUrl(tabName, pageIndex)}`;

  return (
    <Helmet title={title} description={description} keywords={keywords}>
      <link rel="canonical" href={canonical} />
    </Helmet>
  );
};

export default SubjectHelmet;
